export default __webpack_public_path__ + "media/images/ui-icons_454545_256x240-74cd85ab865437626c86d9152952bd43.png";